export default __webpack_public_path__ + "static/media/JobDescription.ffe2f64f.PNG";